import { getSearchState } from 'app/utils/search-state';
import React, { FunctionComponent } from 'react';
import VideoCompareCharts from 'videos/pages/CompareVideos/VideoCompareCharts';
import { compareVideos } from 'videos/Requests';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useModal } from 'app/context/Modal';
import { handelStatusError } from 'app/utils/helpers';
import Loader from 'app/components/Loader';

interface Props {
  isTemplate?: boolean;
}

const VideoCompare: FunctionComponent<Props> = ({ isTemplate }) => {
  const { show } = useModal();
  const videosIds = getSearchState()?.id;
  const { data: videos, isLoading } = useQuery(
    ['compareVideos', videosIds],
    compareVideos,
    {
      onError: (error: any) => {
        handelStatusError(error, show);

        if (error?.response?.status === 401) {
          show({
            isAlternative: true,
            message: error?.response?.data?.message,
          });
        } else {
          toast.error(error?.response?.data?.message);
        }
      },
    }
  );
  if (isLoading) return <Loader />;
  return (
    <>
      <VideoCompareCharts
        isTemplate={isTemplate}
        videosIds={videosIds}
        videos={videos}
        isReport
      />
    </>
  );
};

export default VideoCompare;
